<template>
  <ul class="types">
    <li>
      <button
        class="types__button"
        :class="{ 'types__button--active': isShopAllSelected }"
        @click="handleTypeClick({ productType: null, productMetafield: null })"
      >
        Shop all
      </button>
    </li>
    <li v-if="hasCampaignSaleProducts">
      <button
        class="types__button types__button--campaign-sale"
        :class="{ 'types__button--active': isCampaignSaleSelected }"
        @click="handleCampaignSaleClick"
      >
        12 Days of Discounts
      </button>
    </li>
    <li v-for="productType in types" :key="productType.id">
      <button
        class="types__button"
        :class="{ 'types__button--active': isFilterSelected(productType) }"
        @click="handleTypeClick(productType.input)"
      >
        {{ productType.label }}
      </button>
    </li>
  </ul>
</template>

<script>
import isEqual from "lodash-es/isEqual";
import { mapGetters, mapState } from "vuex";

export default {
  name: "ProductTypes",
  emits: ["change"],
  computed: {
    ...mapState("collection", ["filters"]),
    ...mapGetters("collection", ["types", "availableFilters"]),
    isShopAllSelected() {
      return !this.filters.some(
        ({ productType, productMetafield }) => productType || productMetafield
      );
    },
    isCampaignSaleSelected() {
      return this.filters.some(
        ({ productMetafield }) => productMetafield?.value === "true"
      );
    },
    hasCampaignSaleProducts() {
      return this.availableFilters.some(
        (filter) => filter.id === "filter.p.m.ratandboa.on_campaign_sale"
      );
    },
  },
  methods: {
    isFilterSelected(productType) {
      const { input } = productType;
      const valueInput = JSON.parse(input);
      const filterKey = Object.keys(valueInput)[0];

      return this.filters.some((selectedFilter) =>
        isEqual(selectedFilter[filterKey], valueInput[filterKey])
      );
    },
    handleCampaignSaleClick() {
      const campaignSaleFilter = this.availableFilters.find(
        ({ id }) => id === "filter.p.m.ratandboa.on_campaign_sale"
      );

      if (campaignSaleFilter?.values?.length) {
        this.handleTypeClick(campaignSaleFilter.values[0].input);
      }
    },
    handleTypeClick(input) {
      let emittedValue = input;

      if (typeof input == "string") {
        emittedValue = JSON.parse(input);

        if (!emittedValue.productMetafield) {
          emittedValue = { ...emittedValue, productMetafield: null };
        }
      }

      this.$emit("change", emittedValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.types {
  overflow-y: auto;
  white-space: nowrap;
  display: flex;
  gap: 12px;
  @extend .container;

  @include respond-above(md) {
    flex-wrap: wrap;
    justify-content: center;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  li {
    flex: 0 0 auto;
    display: inline-block;
  }

  &__button {
    padding: 8px 12px;
    background-color: $color-grey-light;
    color: $color-black;
    border-radius: 4px;
    @include utility-button(13px);
    border: none;
    outline: none;
    text-decoration: none;
    text-align: center;

    &--active {
      background-color: $color-black;
      color: $color-white;
    }

    &--campaign-sale {
      background-color: $color-red;
      color: $color-white;

      &.types__button--active {
        background-color: $color-black;
        color: $color-white;
      }
    }
  }
}
</style>
